import React from 'react'
import Hero from '../components/home/Hero'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Plans from '../components/home/Plans'
import Otts from '../components/home/Otts'
import Advantages from '../components/home/Advantages'
import Faq from '../components/home/Faq'
import Contact from '../components/home/Contact'

function Home() {
    return (
        <>
            <Header />
            <Hero />
            <Plans />
            <Otts />
            <Advantages />
            <Faq />
            <Contact />
            <Footer />
        </>
    )
}

export default Home